import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "src/config/axios";
import { Button, Col, InputGroup, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import FormInputText from "src/components/Forms/FormInputText";
import FormCheckbox from "src/components/Forms/FormCheckbox";
import FormSelectBox from "src/components/Forms/FormSelectBox";
import { Formik, Form } from "formik";
import FormCountrySelectBox from "src/components/Forms/FormCountrySelectBox";
import FormMunicipalitySelectBox from "src/components/Forms/FormMunicipalitySelectBox";
import GeneralFormError from "src/components/Forms/GeneralFormError";
import { showSuccessToast } from "src/components/Toasts";
import { keepState } from "../../../../components/UiComponents/Buttons/BackButton/helper";
import BackButton from "../../../../components/UiComponents/Buttons/BackButton";
import history from "../../../../global/history";
import { useTranslation } from "react-i18next";
import moment from "moment";

const EditGuestPage = () => {
  function validate(values) {
    const errors = {};

    if (!values.first_name) {
      errors.first_name = "Vorname ist ein Pflichtfeld";
    }

    if (!values.last_name) {
      errors.last_name = "Nachname ist ein Pflichtfeld";
    }

    if (!values.document_nr) {
      errors.document_nr = "Dokumntnr. ist ein Pflichtfeld";
    }

    if (!values.birth_date) {
      errors.birth_date = "Geburtsdatum ist ein Pflichtfeld";
    }

    if (!values.birth_country) {
      errors.birth_country = "Geburtsland ist ein Pflichtfeld";
    }

    if (!values.citizenship) {
      errors.citizenship = "Staatsbürgerschaft ist ein Pflichtfeld";
    }

    if (!values.document_country_of_issue) {
      errors.document_country_of_issue =
        "Dokumentaustellungsland ist ein Pflichtfeld";
    }

    return errors;
  }

  const { stayId, id } = useParams();
  // const [booking, setBooking] = useState();
  const [guestTemplate, setGuestTemplate] = useState({ settings: {} });
  const [stay, setStay] = useState();
  const [defaultCheckinAt] = useState(
    moment().format(moment.HTML5_FMT.DATETIME_LOCAL)
  );

  const { t } = useTranslation("dashboard");

  function handleSelectionChange(
    field,
    selection,
    setFieldValue,
    setFieldTouched
  ) {
    setFieldValue(field, selection[0]);
    window.setTimeout(() => {
      setFieldTouched(field, true);
    });
  }

  function handleBirthCountryChange(
    selection,
    values,
    setFieldValue,
    setFieldTouched
  ) {
    handleSelectionChange(
      "birth_country",
      selection,
      setFieldValue,
      setFieldTouched
    );

    if (!values.citizenship) {
      setFieldValue("citizenship", selection[0]);
    }

    if (!values.document_country_of_issue) {
      setFieldValue("document_country_of_issue", selection[0]);
    }
  }

  const getGuest = () => {
    axios
      .get(`/api/v1/guests/${id}.json`)
      .then(function (response) {
        setGuestTemplate((guestTemplate) => {
          return { ...guestTemplate, ...response.data };
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getGuestTemplate = () => {
    axios
      .get(`/api/v1/guests/template.json`)
      .then(function (response) {
        setGuestTemplate(response.data);

        if (id) {
          getGuest();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getStay = () => {
    axios
      .get(`/api/v1/stays/${stayId}.json`)
      .then(function (response) {
        setStay(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const formatDateTime = (value) => {
    if (!value) {
      return "";
    }

    return moment(value).format(moment.HTML5_FMT.DATETIME_LOCAL);
  };

  const defaultGuestCheckinAt = () => {
    if (!stay?.from || !stay?.to) {
      return defaultCheckinAt;
    }

    const defaultCheckin = moment(defaultCheckinAt);
    if (
      defaultCheckin.isBefore(moment(stay.from)) ||
      defaultCheckin.isAfter(moment(stay.to))
    ) {
      return formatDateTime(stay.from);
    }

    return defaultCheckinAt;
  };

  const fillForm = () => {
    const form = {};
    if (guestTemplate != null) {
      form.first_name = guestTemplate.first_name ?? "";
      form.last_name = guestTemplate.last_name ?? "";
      form.gender = guestTemplate.gender ?? "";
      form.birth_date = guestTemplate.birth_date ?? "";
      form.citizenship = guestTemplate.citizenship ?? "";
      form.birth_country = guestTemplate.birth_country ?? "";
      form.birth_place = guestTemplate.birth_place ?? "";
      form.document_country_of_issue =
        guestTemplate.document_country_of_issue ?? "";
      form.document_place_of_issue =
        guestTemplate.document_place_of_issue ?? "";
      form.document_nr = guestTemplate.document_nr ?? "";
      form.document_type_id = guestTemplate.document_type?.id;
      form.email = guestTemplate.email ?? "";
      form.phone = guestTemplate.phone ?? "";
      form.checkin_at = formatDateTime(guestTemplate.checkin_at);
      form.checkout_at = formatDateTime(guestTemplate.checkout_at);
      form.checkout_confirmed_at = !!guestTemplate.checkout_confirmed_at;

      if (!id) {
        if (!form.checkin_at) {
          form.checkin_at = defaultGuestCheckinAt();
        }

        if (!form.checkout_at) {
          form.checkout_at = formatDateTime(stay?.to);
        }
      }
    }
    return form;
  };

  useEffect(() => {
    getGuestTemplate();
    getStay();
  }, []);

  function submit(values, options) {
    const guest = { ...values };

    guest.citizenship_id = guest.citizenship?.id;
    guest.document_type = guest.document_type_id;
    guest.birth_country_id = guest.birth_country?.id;
    guest.birth_place_id = guest.birth_place?.id;
    guest.document_country_of_issue_id = guest.document_country_of_issue?.id;
    guest.document_place_of_issue_id = guest.document_place_of_issue?.id;
    guest.checkout_confirmed_at = guest.checkout_confirmed_at
      ? guestTemplate.checkout_confirmed_at ||
        moment().format(moment.HTML5_FMT.DATETIME_LOCAL)
      : null;

    options.setSubmitting(true);

    let request;

    if (id) {
      request = axios.put(`/api/v1/guests/${id}.json`, { guest });
    } else {
      request = axios.post(`/api/v1/stays/${stayId}/guests.json`, { guest });
    }

    request
      .then(function () {
        history.push(`/dashboard/stays/${stayId}`, keepState(history));
        showSuccessToast();
      })
      .catch(function (error) {
        options.setErrors(error.response.data);
        options.setStatus({
          submitErrors: error.response?.data || {},
        });
      })
      .finally(function () {
        options.setSubmitting(false);
      });
  }

  return (
    <>
      <Formik
        initialValues={fillForm()}
        enableReinitialize={true}
        validate={validate}
        onSubmit={submit}
      >
        {({
          values,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
          errors,
          status,
          submitCount,
        }) => (
          <Form autoComplete="false">
            <Row>
              <Col xs={12} lg={8} className="mb-3">
                <Card
                  title={
                    <div className="d-flex w-100 align-items-center text-center">
                      <BackButton route={`/dashboard/stays/${stayId}`} />{" "}
                      <p className="mb-0">Gast Daten</p>
                    </div>
                  }
                >
                  <div className="table-responsive">
                    {submitCount > 0 && (
                      <GeneralFormError
                        errors={status?.submitErrors || errors}
                      />
                    )}

                    <InputGroup className={"d-flex"}>
                      <div className={"mr-3 flex-grow-1"}>
                        <FormInputText
                          label="Vorname"
                          name="first_name"
                          required
                        />
                      </div>
                      <div className={"flex-grow-1"}>
                        <FormInputText
                          label="Nachname"
                          name="last_name"
                          required
                          flex
                        />
                      </div>
                    </InputGroup>

                    <InputGroup className={"d-flex"}>
                      <div className={"mr-3 flex-grow-1"}>
                        <FormSelectBox
                          label="Geschlecht"
                          name="gender"
                          options={guestTemplate?.settings.genders}
                          option_value="id"
                          option_name="name"
                          required
                        />
                      </div>
                      <div className={"flex-grow-1"}>
                        <FormInputText
                          label="Geburtsdatum"
                          type="date"
                          name="birth_date"
                        />
                      </div>
                    </InputGroup>

                    <InputGroup className={"d-flex"}>
                      <div className={"mr-3 flex-grow-1"}>
                        <FormInputText
                          type={"email"}
                          label="E-Mail"
                          name="email"
                        />
                      </div>
                      <div className={"flex-grow-1"}>
                        <FormInputText label="Telefonnummer" name="phone" />
                      </div>
                    </InputGroup>
                    <InputGroup className={"d-flex"}>
                      <FormCountrySelectBox
                        label="Geburtsland"
                        name="birth_country"
                        required
                        className={"mr-3 flex-grow-1"}
                        onChange={(selection) =>
                          handleBirthCountryChange(
                            selection,
                            values,
                            setFieldValue,
                            setFieldTouched
                          )
                        }
                      />

                      {values.birth_country?.iso_code === "IT" && (
                        <>
                          <FormMunicipalitySelectBox
                            label="Geburtsort"
                            name="birth_place"
                            required
                            className={"mb-3 flex-grow-1"}
                            onChange={(selection) =>
                              handleSelectionChange(
                                "birth_place",
                                selection,
                                setFieldValue,
                                setFieldTouched
                              )
                            }
                          />
                        </>
                      )}
                    </InputGroup>

                    <FormCountrySelectBox
                      label="Staatsbürgerschaft"
                      name="citizenship"
                      required
                      onChange={(selection) =>
                        handleSelectionChange(
                          "citizenship",
                          selection,
                          setFieldValue,
                          setFieldTouched
                        )
                      }
                    />

                    <InputGroup>
                      <FormCountrySelectBox
                        label="Dokumentaustellungsland"
                        name="document_country_of_issue"
                        required
                        className={"mr-3 flex-grow-1"}
                        onChange={(selection) =>
                          handleSelectionChange(
                            "document_country_of_issue",
                            selection,
                            setFieldValue,
                            setFieldTouched
                          )
                        }
                      />

                      {values.document_country_of_issue?.iso_code === "IT" && (
                        <FormMunicipalitySelectBox
                          label="Dokumentausstellungsort"
                          name="document_place_of_issue"
                          required
                          className={"flex-grow-1"}
                          onChange={(selection) =>
                            handleSelectionChange(
                              "document_place_of_issue",
                              selection,
                              setFieldValue,
                              setFieldTouched
                            )
                          }
                        />
                      )}
                    </InputGroup>

                    <InputGroup>
                      <FormSelectBox
                        className={"mr-3 flex-grow-1"}
                        label="Dokumententyp"
                        name="document_type_id"
                        options={guestTemplate?.settings.document_types}
                        option_value="id"
                        option_name="name"
                        required
                      />
                      <FormInputText
                        label="Dokumentnr."
                        name="document_nr"
                        required
                        className={"flex-grow-1"}
                      />
                    </InputGroup>
                    <Button
                      disabled={isSubmitting}
                      variant="primary"
                      type="submit"
                    >
                      {t("common:components.button.save")}
                    </Button>
                  </div>
                </Card>
              </Col>

              <Col xs={12} lg={4} className="mb-3">
                <Card title="Aufenthalt">
                  <FormInputText
                    label="Check-In"
                    type="datetime-local"
                    name="checkin_at"
                    min={formatDateTime(stay?.from)}
                    max={values.checkout_at || formatDateTime(stay?.to)}
                    disabled={values.checkout_confirmed_at}
                  />
                  <FormInputText
                    label="Check-out"
                    type="datetime-local"
                    name="checkout_at"
                    min={values.checkin_at || formatDateTime(stay?.from)}
                    max={formatDateTime(stay?.to)}
                    disabled={values.checkout_confirmed_at}
                  />
                  <FormCheckbox
                    name="checkout_confirmed_at"
                    label="Checkout bestätigt"
                  />
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default EditGuestPage;
